// import React, { useRef, useEffect, useState } from "react";
// import axios from "axios";

// const BASE_URL = "https://ecom.cyberathon.com";
// const API_URL = BASE_URL + "/index.php/Blank/list_collections";

// const HomeCollection = () => {
//   const scrollRef = useRef(null);
//   const [collections, setCollections] = useState([]);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const res = await axios.get(API_URL);
//         setCollections(res.data.data || []);
//       } catch (err) {
//         console.error("API Error:", err);
//       }
//     };

//     fetchData();
//   }, []);

//   // Auto Scroll
//   useEffect(() => {
//     const scrollContainer = scrollRef.current;
//     let scrollAmount = 1.5;
//     let scrollInterval;

//     const startScroll = () => {
//       scrollInterval = setInterval(() => {
//         if (scrollContainer) {
//           scrollContainer.scrollLeft += scrollAmount;

//           if (
//             scrollContainer.scrollLeft >=
//             scrollContainer.scrollWidth - scrollContainer.clientWidth
//           ) {
//             scrollContainer.scrollLeft = 0;
//           }
//         }
//       }, 20);
//     };

//     startScroll();
//     return () => clearInterval(scrollInterval);
//   }, []);

//   return (
//     <div className="container-fluid py-5 px-md-5 px-sm-0 color_bg_scroll">
//       <h3 className="text-start pb-3">Shop By Collections</h3>

//       <div
//         ref={scrollRef}
//         className="d-flex flex-nowrap overflow-hidden gap-4 px-4"
//       >
//         {collections.concat(collections).map((item, index) => (
//           <div key={index} className="card scroll-card">
//             <img
//               src={`${BASE_URL}/${item.image}`}
//               alt={item.heading}
//               className="card-img-top img_light"
//             />
//             <div className="card-body text-center py-2">
//               <h6 className="card-title me-1 fw-bold">{item.heading}</h6>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default HomeCollection;









// 21-10-2026 client ne bola scroll jo hai collection wo clickable ho
import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://ecom.cyberathon.com";
const API_URL = BASE_URL + "/index.php/Blank/list_collections";

const HomeCollection = () => {
  const scrollRef = useRef(null);
  const [collections, setCollections] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(API_URL);
        setCollections(res.data.data || []);
      } catch (err) {
        console.error("API Error:", err);
      }
    };
    fetchData();
  }, []);

  // Auto Scroll (same as before)
  useEffect(() => {
    const scrollContainer = scrollRef.current;
    let scrollAmount = 1.5;
    let scrollInterval;

    const startScroll = () => {
      scrollInterval = setInterval(() => {
        if (scrollContainer) {
          scrollContainer.scrollLeft += scrollAmount;
          if (
            scrollContainer.scrollLeft >=
            scrollContainer.scrollWidth - scrollContainer.clientWidth
          ) {
            scrollContainer.scrollLeft = 0;
          }
        }
      }, 20);
    };

    startScroll();
    return () => clearInterval(scrollInterval);
  }, []);

  const handleCollectionClick = (item) => {
    if (!item.prod_id) return; // link nahi hai to kuch mat karo
    navigate(`/DetailsSection3/${item.prod_id}`);
  };

  return (
    <div className="container-fluid py-5 px-md-5 px-sm-0 color_bg_scroll">
      <h3 className="text-start pb-3">Shop By Collections</h3>

      <div
        ref={scrollRef}
        className="d-flex flex-nowrap overflow-hidden gap-4 px-4"
      >
        {collections.concat(collections).map((item, index) => (
          <div
            key={index}
            className="card scroll-card"
            style={{ cursor: item.prod_id ? "pointer" : "default" }}
            onClick={() => handleCollectionClick(item)}
          >
            <img
              src={`${BASE_URL}/${item.image}`}
              alt={item.heading}
              className="card-img-top img_light"
            />
            <div className="card-body text-center py-2">
              <h6 className="card-title me-1 fw-bold">{item.heading}</h6>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeCollection;